import type { InformationUpdate } from '../api/mutations';
import type { AccountInfo } from '../api/queries';

/** The fields the settings form lets the user edit. */
export interface SettingsValues {
    displayName: string;
    language: string;
    tempUnit: string;
    entryPage: string;
}

/** The account's current values, with the app's defaults for anything unset. */
export const toSettingsValues = (info: AccountInfo | undefined): SettingsValues => ({
    displayName: info?.display_name || '',
    language: info?.preference?.language || 'english',
    tempUnit: info?.preference?.temp_unit || 'celsius',
    entryPage: info?.preference?.entry_page || 'overview',
});

/** The save request; email and phone aren't editable here, so they go back as loaded. */
export const toInformationUpdate = (values: SettingsValues, info: AccountInfo): InformationUpdate => ({
    company_name: values.displayName,
    phone_number: info.phone_number || '',
    email: info.email || '',
    temp_unit: values.tempUnit,
    language: values.language,
    entry_page: values.entryPage,
});
